<div
  class="time-range"
  nz-tooltip
  [nzTooltipTitle]="range.message | truncate"
  [nzTooltipColor]="'#4caf50'"
  [style.left]="leftPx"
  [style.width]="widthPx"
  (click)="onRangeClick()"
></div>

<nz-modal
  [nzWidth]="'80%'"
  [(nzVisible)]="isPopoverVisible"
  [nzTitle]="undefined"
  [nzCancelText]="'Close'"
  (nzOnCancel)="handleCancel()"
  [nzOkText]="null"
>
  <ng-container *nzModalContent>
    <div class="popover-body">
      <app-feedback-improvements
        [session]="session"
        [index]="index"
        [range]="range"
        [sessionMessageList]="sessionMessageList"
      ></app-feedback-improvements>
    </div>
  </ng-container>
</nz-modal>
